var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Cloud2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 61,
    viewBox: "0 0 133 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.294 60.818C137.076 60.818 138.285 29.3946 117.465 28.3724H115.746C112.129 28.3701 108.534 28.9321 105.09 30.0382C103.702 21.5536 99.316 13.8518 92.7317 8.33824C86.1473 2.82466 77.804 -0.133129 69.2241 0.00460208C60.6441 0.142333 52.3996 3.3664 45.995 9.08848C39.5903 14.8106 35.4525 22.6492 34.3366 31.174C29.8985 29.0349 25.0352 27.9283 20.1103 27.937C17.3254 27.9343 14.5514 28.2841 11.8541 28.9781C-6.37744 33.6917 -2.54221 60.8559 16.275 60.8559L116.294 60.818Z",
    fill: "#A0B9DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Cloud2);
export default __webpack_public_path__ + "static/media/404_cloud_2.20aa09ccc873d299827776048d50a9b0.svg";
export { ForwardRef as ReactComponent };